import ChangeOrder from '../../services/changeOrder'
import * as types from '../mutationTypes'

let state = {
  error: null,
  changeOrder: null,
  changeOrdersByTask: [],
  changeOrders: [],
  status: null
}

const getters = {
  error (state) {
    return state.error
  },
  changeOrder (state) {
    return state.changeOrder
  },
  changeOrdersByTask (state) {
    return state.changeOrdersByTask
  },
  changeOrders (state) {
    return state.changeOrders
  },
  status (state) {
    return state.status
  }
}

const actions = {
  async loadAll ({ commit, dispatch }, limit, offset) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await ChangeOrder.getAll(limit, offset)
      if (res) {
        commit(types.REQUEST_GET_ALL_CHANGE_ORDERS_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_ALL_CHANGE_ORDERS_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadByTask ({ commit, dispatch }, taskId) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await ChangeOrder.getByTask(taskId)
      if (res) {
        let data = res.data
        data.forEach(co => {
          let status = 'Pending'
          if (co.status !== status) {
            status = 'Submitted'
          }
          for (let i = 0; i < co.documents.length; i++) {
            if (co.documents[i].status === status) {
              co.lastDoc = co.documents[i]
            }
          }
        })
        commit(types.REQUEST_GET_CHANGE_ORDERS_BY_TASK_SUCCESS, data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_CHANGE_ORDERS_BY_TASK_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async loadChangeOrder ({ commit, dispatch }, id) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await ChangeOrder.get(id)
      if (res) {
        commit(types.REQUEST_GET_CHANGE_ORDER_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_CHANGE_ORDER_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async createChangeOrder ({ commit, dispatch }, changeOrder) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await ChangeOrder.create(changeOrder)
      if (res) {
        commit(types.REQUEST_CREATE_CHANGE_ORDER_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_CREATE_CHANGE_ORDER_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async updateChangeOrder ({ commit, dispatch }, changeOrder) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await ChangeOrder.update(changeOrder)
      if (res) {
        commit(types.REQUEST_UPDATE_CHANGE_ORDER_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_UPDATE_CHANGE_ORDER_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  async deleteChangeOrder ({ commit, dispatch }, id) {
    dispatch('loadingIndicator/enableLoadingIndicator', null, { root: true })
    try {
      let res = await ChangeOrder.delete(id)
      if (res) {
        commit(types.REQUEST_DELETE_CHANGE_ORDER_SUCCESS, res.data)
        dispatch('loadByTask', res.data.workOrderTaskId)
      }
    } catch (err) {
      commit(types.REQUEST_DELETE_CHANGE_ORDER_ERROR, err)
    }
    dispatch('loadingIndicator/disableLoadingIndicator', null, { root: true })
  },
  clearErrors ({ commit }) {
    commit(types.CLEAR_ERROR_CHANGE_ORDER)
  },
  clearChangeTasks ({ commit }) {
    commit(types.CLEAR_CHANGE_TASK)
  }
}

const mutations = {
  [types.REQUEST_GET_ALL_CHANGE_ORDERS_SUCCESS] (state, data) {
    state.error = null
    state.changeOrders = data
    state.status = 'Success'
  },
  [types.REQUEST_GET_ALL_CHANGE_ORDERS_ERROR] (state, error) {
    state.error = error
    state.changeOrders = []
    state.status = 'Error'
  },
  [types.REQUEST_GET_CHANGE_ORDERS_BY_TASK_SUCCESS] (state, data) {
    state.error = null
    state.status = 'Success'
    state.changeOrdersByTask = data
  },
  [types.REQUEST_GET_CHANGE_ORDERS_BY_TASK_ERROR] (state, error) {
    state.error = error
    state.status = 'Error'
    state.changeOrdersByTask = []
  },
  [types.REQUEST_GET_CHANGE_ORDER_SUCCESS] (state, data) {
    state.error = null
    state.status = 'Success'
    state.changeOrder = data
  },
  [types.REQUEST_GET_CHANGE_ORDER_ERROR] (state, error) {
    state.error = error
    state.status = 'Error'
    state.changeOrder = null
  },
  [types.REQUEST_CREATE_CHANGE_ORDER_SUCCESS] (state, data) {
    state.error = null
    state.status = 'Success'
    state.changeOrder = data
  },
  [types.REQUEST_CREATE_CHANGE_ORDER_ERROR] (state, error) {
    state.error = error
    state.status = 'Error'
    state.changeOrder = null
  },
  [types.REQUEST_UPDATE_CHANGE_ORDER_SUCCESS] (state, data) {
    state.error = null
    state.status = 'Success'
    state.changeOrder = data
  },
  [types.REQUEST_UPDATE_CHANGE_ORDER_ERROR] (state, error) {
    state.error = error
    state.status = 'Error'
    state.changeOrder = null
  },
  [types.REQUEST_DELETE_CHANGE_ORDER_SUCCESS] (state, data) {
    state.error = null
    state.status = 'Success'
    state.changeOrder = null
  },
  [types.REQUEST_DELETE_CHANGE_ORDER_ERROR] (state, error) {
    state.error = error
    state.status = 'Error'
  },
  [types.CLEAR_ERROR_CHANGE_ORDER] (state) {
    state.error = null
    state.status = null
  },
  [types.CLEAR_CHANGE_TASK] (state) {
    state.changeOrdersByTask = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
